import { defineMessages } from 'react-intl';

const taxTypes = defineMessages({
  vat: {
    id: 'shared_components.invoice_page.vat',
    defaultMessage: 'VAT'
  },
  qst: {
    id: 'shared_components.invoice_page.qst',
    defaultMessage: 'QST'
  },
  pst: {
    id: 'shared_components.invoice_page.pst',
    defaultMessage: 'PST'
  },
  rst: {
    id: 'shared_components.invoice_page.rst',
    defaultMessage: 'RST'
  },
  gst: {
    id: 'shared_components.invoice_page.gst',
    defaultMessage: 'GST'
  },
  hst: {
    id: 'shared_components.invoice_page.hst',
    defaultMessage: 'HST'
  },
  gstHst: {
    id: 'shared_components.invoice_page.gst_hst',
    defaultMessage: 'GST/HST'
  }
});

export const intlTaxTypes = {
  VAT: taxTypes.vat,
  QST: taxTypes.qst,
  PST: taxTypes.pst,
  RST: taxTypes.rst,
  GST: taxTypes.gst,
  HST: taxTypes.hst,
  gst_hst: taxTypes.gstHst
}

const taxTypeDetails = defineMessages({
  vat: {
    id: 'shared_components.invoice_page.vat_details',
    defaultMessage: 'VAT details'
  },
  gst: {
    id: 'shared_components.invoice_page.gst_details',
    defaultMessage: 'GST details'
  },
  hst: {
    id: 'shared_components.invoice_page.hst_details',
    defaultMessage: 'HST details'
  },
  pst: {
    id: 'shared_components.invoice_page.pst_details',
    defaultMessage: 'PST details'
  },
  rst: {
    id: 'shared_components.invoice_page.rst_details',
    defaultMessage: 'RST details'
  },
  qst: {
    id: 'shared_components.invoice_page.qst_details',
    defaultMessage: 'QST details'
  },
  salesTax: {
    id: 'shared_components.invoice_page.sales_tax_details',
    defaultMessage: 'Sales tax details'
  }
});

export const intlTaxTypeDetails = {
  VAT: taxTypeDetails.vat,
  GST: taxTypeDetails.gst,
  HST: taxTypeDetails.hst,
  PST: taxTypeDetails.pst,
  RST: taxTypeDetails.rst,
  QST: taxTypeDetails.qst,
  other: taxTypeDetails.salesTax
}

const taxTypeId = defineMessages({
  vat: {
    id: 'shared_components.invoice_page.vat_id',
    defaultMessage: 'VAT ID'
  },
  gst: {
    id: 'shared_components.invoice_page.gst_id',
    defaultMessage: 'GST ID'
  },
  rst: {
    id: 'shared_components.invoice_page.rst_id',
    defaultMessage: 'RST ID'
  },
  pst: {
    id: 'shared_components.invoice_page.pst_id',
    defaultMessage: 'PST ID'
  },
  qst: {
    id: 'shared_components.invoice_page.qst_id',
    defaultMessage: 'QST ID'
  },
  hst: {
    id: 'shared_components.invoice_page.hst_id',
    defaultMessage: 'QST ID'
  }
});

export const intlTaxTypeId = {
  VAT: taxTypeId.vat,
  GST: taxTypeId.gst,
  RST: taxTypeId.rst,
  PST: taxTypeId.pst,
  QST: taxTypeId.qst
}

const taxChargesType = defineMessages({
  vat: {
    id: 'shared_components.invoice_page.vat_charges',
    defaultMessage: 'VAT charges'
  },
  qst: {
    id: 'shared_components.invoice_page.qst_charges',
    defaultMessage: 'QST charges'
  },
  pst: {
    id: 'shared_components.invoice_page.pst_charges',
    defaultMessage: 'PST charges'
  },
  rst: {
    id: 'shared_components.invoice_page.rst_charges',
    defaultMessage: 'RST charges'
  },
  gst: {
    id: 'shared_components.invoice_page.gst_charges',
    defaultMessage: 'GST charges'
  },
  hst: {
    id: 'shared_components.invoice_page.hst_charges',
    defaultMessage: 'HST charges'
  }
});

export const intlTaxChargesType = {
  VAT: taxChargesType.vat,
  QST: taxChargesType.qst,
  PST: taxChargesType.pst,
  RST: taxChargesType.rst,
  GST: taxChargesType.gst,
  HST: taxChargesType.hst
}

const taxTypeCharged = defineMessages({
  vat: {
    id: 'shared_components.invoice_page.vat_charged',
    defaultMessage: 'VAT charged'
  },
  qst: {
    id: 'shared_components.invoice_page.qst_charged',
    defaultMessage: 'QST charged'
  },
  pst: {
    id: 'shared_components.invoice_page.pst_charged',
    defaultMessage: 'PST charged'
  },
  rst: {
    id: 'shared_components.invoice_page.rst_charged',
    defaultMessage: 'RST charged'
  },
  gst: {
    id: 'shared_components.invoice_page.gst_charged',
    defaultMessage: 'GST charged'
  },
  hst: {
    id: 'shared_components.invoice_page.hst_charged',
    defaultMessage: 'HST charged'
  }
});

export const intlTaxTypeCharged = {
  VAT: taxTypeCharged.vat,
  QST: taxTypeCharged.qst,
  PST: taxTypeCharged.pst,
  RST: taxTypeCharged.rst,
  GST: taxTypeCharged.gst,
  HST: taxTypeCharged.hst
}

const taxTypeCredited = defineMessages({
  vat: {
    id: 'shared_components.invoice_page.vat_credited',
    defaultMessage: 'VAT credited'
  },
  qst: {
    id: 'shared_components.invoice_page.qst_credited',
    defaultMessage: 'QST credited'
  },
  pst: {
    id: 'shared_components.invoice_page.pst_credited',
    defaultMessage: 'PST credited'
  },
  rst: {
    id: 'shared_components.invoice_page.rst_credited',
    defaultMessage: 'RST credited'
  },
  gst: {
    id: 'shared_components.invoice_page.gst_credited',
    defaultMessage: 'GST credited'
  },
  hst: {
    id: 'shared_components.invoice_page.hst_credited',
    defaultMessage: 'HST credited'
  }
});

export const intlTaxTypeCredited= {
  VAT: taxTypeCredited.vat,
  QST: taxTypeCredited.qst,
  PST: taxTypeCredited.pst,
  RST: taxTypeCredited.rst,
  GST: taxTypeCredited.gst,
  HST: taxTypeCredited.hst
}

const txnType = defineMessages({
  charge: {
    id: 'shared_components.invoice_page.charge_for_booking_text',
    defaultMessage: 'Charge for booking'
  },
  refund: {
    id: 'shared_components.invoice_page.refund_for_booking_text',
    defaultMessage: 'Refund for booking'
  }
});

export const intlTxnType = {
  CHARGE: txnType.charge,
  REFUND: txnType.refund
}

const reverseChargeCopyType = defineMessages({
  vat: {
    id: 'shared_components.invoice_page.vat_reverse_charge_copy',
    defaultMessage: 'A reverse charge was applied to the VAT on any booking where your VAT was stored in your profile at the time the booking was accepted. You were not charged VAT on these bookings.'
  },
  gst: {
    id: 'shared_components.invoice_page.gst_reverse_charge_copy',
    defaultMessage: 'A reverse charge was applied to the GST on any booking where your GST was stored in your profile at the time the booking was accepted. You were not charged GST on these bookings.'
  },
  hst: {
    id: 'shared_components.invoice_page.hst_reverse_charge_copy',
    defaultMessage: 'A reverse charge was applied to the HST on any booking where your HST was stored in your profile at the time the booking was accepted. You were not charged HST on these bookings.'
  },
  pst: {
    id: 'shared_components.invoice_page.pst_reverse_charge_copy',
    defaultMessage: 'A reverse charge was applied to the PST on any booking where your PST was stored in your profile at the time the booking was accepted. You were not charged PST on these bookings.'
  },
  qst: {
    id: 'shared_components.invoice_page.qst_reverse_charge_copy',
    defaultMessage: 'A reverse charge was applied to the QST on any booking where your QST was stored in your profile at the time the booking was accepted. You were not charged QST on these bookings.'
  },
  rst: {
    id: 'shared_components.invoice_page.rst_reverse_charge_copy',
    defaultMessage: 'A reverse charge was applied to the RST on any booking where your RST was stored in your profile at the time the booking was accepted. You were not charged RST on these bookings.'
  }
});

export const intlReverseChargeCopyType = {
  VAT: reverseChargeCopyType.vat,
  QST: reverseChargeCopyType.qst,
  PST: reverseChargeCopyType.pst,
  RST: reverseChargeCopyType.rst,
  GST: reverseChargeCopyType.gst,
  HST: reverseChargeCopyType.hst
}
